module.exports = __webpack_public_path__ + "img/hr-steam-engine-H.2e020442.png";